import { 
  CodeBracketIcon,
  PaintBrushIcon,
  UserIcon,
  ShieldCheckIcon,
  CogIcon
} from "@heroicons/react/24/outline";
import type { ResourceTypeConfig } from "./resourcesPhase.types";

export const RESOURCE_TYPE_CONFIG: Record<string, ResourceTypeConfig> = {
  developer: {
    label: "Desenvolvedor",
    color: "blue",
    defaultRate: 80,
    description: "Desenvolvimento de software, APIs e integrações",
    icon: CodeBracketIcon,
  },
  designer: {
    label: "Designer",
    color: "purple",
    defaultRate: 60,
    description: "UI/UX design, protótipos e identidade visual",
    icon: PaintBrushIcon,
  },
  pm: {
    label: "Gerente de Projeto",
    color: "green",
    defaultRate: 90,
    description: "Gestão, planejamento e coordenação do projeto",
    icon: UserIcon,
  },
  qa: {
    label: "QA/Tester",
    color: "orange",
    defaultRate: 50,
    description: "Testes, validação de qualidade e bug fixes",
    icon: ShieldCheckIcon,
  },
  devops: {
    label: "DevOps",
    color: "indigo",
    defaultRate: 85,
    description: "Infraestrutura, deploy e monitoramento",
    icon: CogIcon,
  },
};

export const SENIORITY_MULTIPLIER = {
  junior: 0.7,
  pleno: 1.0,
  senior: 1.4,
  tech_lead: 1.8,
};

export const PROJECT_PHASES_EFFORT_MULTIPLIER = {
  description: 0.05,
  objectives: 0.05,
  technical_solution: 0.10,
  milestones: 0.05,
  stories: 0.15,
  schema: 0.20,
  resources: 0.05,
  proposal: 0.05,
  execution: 0.30,
};

export const DEFAULT_HOURLY_RATES = {
  developer: {
    junior: 56,      // 80 * 0.7
    pleno: 80,       // 80 * 1.0
    senior: 112,     // 80 * 1.4
    tech_lead: 144,  // 80 * 1.8
  },
  designer: {
    junior: 42,      // 60 * 0.7
    pleno: 60,       // 60 * 1.0
    senior: 84,      // 60 * 1.4
    tech_lead: 108,  // 60 * 1.8
  },
  pm: {
    junior: 63,      // 90 * 0.7
    pleno: 90,       // 90 * 1.0
    senior: 126,     // 90 * 1.4
    tech_lead: 162,  // 90 * 1.8
  },
  qa: {
    junior: 35,      // 50 * 0.7
    pleno: 50,       // 50 * 1.0
    senior: 70,      // 50 * 1.4
    tech_lead: 90,   // 50 * 1.8
  },
  devops: {
    junior: 60,      // 85 * 0.7
    pleno: 85,       // 85 * 1.0
    senior: 119,     // 85 * 1.4
    tech_lead: 153,  // 85 * 1.8
  },
};

export function calculateResourceCost(
  hours: number, 
  hourlyRate: number
): number {
  return Math.round(hours * hourlyRate);
}

export function generateResourceId(): string {
  return `resource_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}

export function getResourceTypeColor(type: string): string {
  return RESOURCE_TYPE_CONFIG[type]?.color || "gray";
}

export function getResourceTypeIcon(type: string) {
  return RESOURCE_TYPE_CONFIG[type]?.icon || UserIcon;
}